export const reloadCurrentPage = (): void => {
  if (typeof window !== "undefined") {
    window.location.reload();
  }
};
